import VerifyPhoneReminderModal from './VerifyPhoneReminderModal';

export default VerifyPhoneReminderModal;
